import { render, staticRenderFns } from "./MessageInfo.vue?vue&type=template&id=3d372dd4&scoped=true&"
import script from "./MessageInfo.vue?vue&type=script&lang=js&"
export * from "./MessageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d372dd4",
  null
  
)

export default component.exports